import React from 'react';
import Header from '../../components/Layout/Header';
import './Department.css';

const HR: React.FC = () => {
  return (
    <div className="department-page">
      <Header />
      <div className="department-container">
        <div className="department-header">
          <h1>Human Resources Department</h1>
          <p className="department-description">
            Welcome to the HR Department page. Here you can find information, resources, and updates related to Human Resources.
          </p>
        </div>
        <div className="department-content">
          <div className="department-card">
            <h3>About HR Department</h3>
            <p>
              The Human Resources Department is responsible for managing employee relations, recruitment, 
              training and development, performance management, and ensuring compliance with labor laws and regulations.
            </p>
          </div>
          <div className="department-card">
            <h3>Key Functions</h3>
            <ul>
              <li>Recruitment and Selection</li>
              <li>Employee Onboarding</li>
              <li>Performance Management</li>
              <li>Training and Development</li>
              <li>Compensation and Benefits</li>
              <li>Employee Relations</li>
            </ul>
          </div>
          <div className="department-card">
            <h3>Contact Information</h3>
            <p>For HR-related inquiries, please contact the HR Department.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HR;

